var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"beianContain"},[_c('span',[_vm._v("台州小安科技有限公司")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("浙ICP备2025179184号-1")])])
}]

export { render, staticRenderFns }